/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from "../icetypes";
import { subtypereference } from '../ehr/subs/subtypereference';

export class superbill extends IceEntity {
  superbill_key: string = "";
  name: string = "";
  taxonomy_code: string = "";
  account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  show_signature: boolean = false;
  all_fees_paid_label: string = "";
  show_all_fees_paid: boolean = false;
  diagnosis_submitted_label: string = "";
  show_diagnosis_submitted: boolean = false;
  diagnosis_note_label: boolean = false;
  record_version: number = 0;
  offline_record_status: number = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";

  SUBTYPES: subtypereference[] = [];

  constructor() {
    super();
  }

  gettablename(): string {
    return "SUPERBILL";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "SUBTYPES") return true;

    return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "SUBTYPES") return "SUB_TYPE_REFERENCE";

    return null;
  }
}
